import * as React from "react";
import "./FormCalendar.css"
import Calendar from 'react-calendar';
import {isMobile} from "react-device-detect";
import FormMobileCalendar from "../FormMobileCalendar/FormMobileCalendar";

interface IProps {
    onDateSelected: (date: Date) => void;
    store: any;
}

export default class FormCalendar  extends React.Component<
    IProps
    > {
    public state = {
        date: new Date(),
        showCalendar: false
    };

    public change = (date: any) => {
        const {onDateSelected} = this.props;
        const newState = this.state;
        newState.date = date;
        this.setState(newState);
        onDateSelected(this.state.date);
    };

    public isDateDisabled = (props: any ) => {
        return props.date < new Date();
    };

    public openCalendar = () => {
        const newState = this.state;
        newState.showCalendar = true;
        this.setState(newState);
    };

    public renderCalendar = () => {
        const {store} = this.props;
        const calendarElement = ( <Calendar
            showNeighboringMonth={true}
            prev2Label={null}
            next2Label={null}
            value={undefined}
            tileDisabled={this.isDateDisabled}
            className="form-react-calendar"
            onChange={this.change}
        />);
        return isMobile? <FormMobileCalendar store={store} onSelect={this.change}/> : calendarElement;
    }


    public render() {
        return (
            <>{this.renderCalendar()}</>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/FormCalendar/FormCalendar.tsx